import { createComponent } from '@front/utils/alpine';
const Callback = createComponent(() => ({
    recontactDate: '',
    formError: '',
    validateForm() {
        this.formError = '';
        if (!this.recontactDate) {
            this.formError = 'Veuillez sélectionner une date de rappel.';
            return false;
        }
        return true;
    },
}));
export { Callback };
